export default {
  text: 'Ouvrir le profil {{paymentGateway}}',
  text_generic: "Ouvrir le profil d'intégration",
  toasts: {
    failed_to_create: "Échec de l'ouverture du profil {{paymentGateway}}",
    link_copied: 'Lien copié dans le presse-papiers',
    copy_failed: 'Échec de la copie du lien',
  },
};
